import type { FC, FormEventHandler } from 'react';
import React, { useState } from 'react';
import { OldInput } from '@ui';
import { observer } from 'mobx-react';
import AuthFormBtn from '@components/AuthForm/components/AuthFormBtn';

interface AuthFormEmailProps {
  userEmail: string;
  authViaEmail: ({
    email,
    password
  }: {
    email: string;
    password: string;
  }) => void;
  goToRestorePassModal: () => void;
  userExists: boolean;
}

const AuthFormEmail: FC<AuthFormEmailProps> = ({
  userEmail,
  authViaEmail,
  goToRestorePassModal,
  userExists
}) => {
  const [formData, setFormData] = useState({ pass: { value: '', error: '' } });
  const getInputData = ({ name, value }): void => {
    setFormData({ ...formData, [name]: { ...formData[name], value } });
  };
  const setInputError = ({ name, error }): void => {
    setFormData({ ...formData, [name]: { ...formData[name], error } });
  };
  const onBtnClickHandler = (): void => {
    if (formData.pass.value.length > 3) {
      authViaEmail({ email: userEmail, password: formData.pass.value });
    } else {
      setInputError({
        name: 'pass',
        error: 'Минимальная длина пароля 4 символа'
      });
    }
  };
  const onSubmit: FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
  };
  return (
    <form onSubmit={onSubmit}>
      <div className='AuthForm__heading'>{userEmail}</div>
      <input
        type='text'
        value={userEmail}
        style={{ display: 'none' }}
        readOnly
      />
      <OldInput
        className='mb-6 text-center'
        placeholder='Пароль'
        getInputData={getInputData}
        field='pass'
        name='pass'
        value={formData.pass.value}
        error={formData.pass.error}
      />
      <AuthFormBtn
        type='submit'
        disabled={Number(formData?.pass?.value?.length || 0) < 4}
        onClick={onBtnClickHandler}
      >
        {userExists ? 'Вход' : 'Регистрация'}
      </AuthFormBtn>
      {userExists && (
        <div onClick={goToRestorePassModal} className='AuthForm__text-btn'>
          Забыли пароль?
        </div>
      )}
    </form>
  );
};

export default observer(AuthFormEmail);
